import React from 'react';
import PropTypes from 'prop-types';
import Maybe from 'react-maybe';
// import { Typo, Separator } from '@ers/ui/';
import { AdditionalInfoTypes } from '@ers/data';
// import { Section } from '..';
import * as Components from './additionalDataComponents';

const getComponent = (field, translations) => {
    const component = Components[AdditionalInfoTypes[field.type]];
    return (
        <React.Fragment key={field.key}>
            <Maybe
                of={field.order}
                either={(
                    <>
                        {React.createElement(component, { field, translations })}
                    </>
                )}
                orElse={null}
            />
        </React.Fragment>
    );
};

const AdditionalData = ({ form, translations }) => (
    <>
        {form.additionalInfo.map((field) => getComponent(field, translations))}
        {form.customTextFields.length > 0 && <Components.CustomTextFields field={form.customTextFields} translations={translations} />}
    </>
);
AdditionalData.propTypes = {
    form: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export const defaultPropTypes = {
    field: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default AdditionalData;
